import type { EmojiEntry, SkinTone } from './types';
import { SKIN_TONES } from './types';

const STORAGE_KEY = 'aamusankari.emojiPicker.skinTone';

export function applySkinTone(entry: EmojiEntry, tone: SkinTone | null): string {
  if (!tone || !entry.hasSkinTone || !entry.skinToneVariants) return entry.emoji;
  const idx = SKIN_TONES.indexOf(tone);
  if (idx < 0) return entry.emoji;
  return entry.skinToneVariants[idx] ?? entry.emoji;
}

export function loadSavedSkinTone(): SkinTone | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  return SKIN_TONES.includes(raw as SkinTone) ? (raw as SkinTone) : null;
}

export function saveSkinTone(tone: SkinTone | null): void {
  if (typeof localStorage === 'undefined') return;
  if (tone === null) localStorage.removeItem(STORAGE_KEY);
  else localStorage.setItem(STORAGE_KEY, tone);
}
